<template>
  <div class="filter" @click.stop="showSelectPop">
    <img src="@/assets/icons/filter.png" alt="" />
    <ul v-show="isShow" class="filterUl">
      <li
        @click.stop="call(item, indx)"
        class="oclass"
        :class="{ active: activeIndex == indx }"
        v-for="(item, indx) in list"
        :key="item.value"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "statusFilter",
  props: {
    list: {
      type: Array,
      default: [],
    },
    currTab: {
      type: Number,
      default: null,
    },
    tab: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    document.body.addEventListener("click", (event) => {
      if (
        "oclass" !== event.target.className ||
        event.target.className.indexOf("oclass") < 0
      ) {
        setTimeout(() => {
          this.isShow = false;
        }, 10);
      }
    });
  },
  computed: {},
  watch: {
    currTab: function (val) {
      if (val != this.tab) {
        this.activeIndex = null;
      }
    },
  },
  data() {
    return {
      isShow: false,
      activeIndex: null,
    };
  },
  methods: {
    showSelectPop() {
      document.getElementsByClassName('filterUl').forEach(item=>{
        item.style.display='none'
      })
      this.isShow = !this.isShow;
      /* this.$emit('on-selectMain') */
    },
    call(item, indx) {
      this.activeIndex = indx;
      this.$emit("on-select", item);
      this.isShow = !this.isShow;
    },
  },
};
</script>

<style scoped lang="less">
.filter {
  display: inline-block;
  position: relative;
  img {
    width: 16px;
    position: relative;
    top: 5px;
    right: 8px;
  }
}
.filterUl {
  z-index: 99;
  min-width: 120px;
  background-color: #fff;
  position: absolute;
  right: 0;
  top: 30px;
  box-shadow: 0 0 10px #aaa;
  padding: 10px;
  margin-top: 0 !important;
  list-style: none;
  li {
    padding: 3px 10px !important;
    &:hover {
      background-color: #eee;
    }
    &.active {
      background-color: #f00;
      color: #fff;
    }
  }
}
</style>
